// tabsTheme.js
import { createTheme } from "@mui/material/styles";

const tabsTheme = createTheme({
  palette: {
    primary: {
      main: "#4CAF50",
    },
  },

  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: "42px",
          padding: 0,
            // ✅ Add grey bottom line
          borderBottom: "1px solid #e0e0e0",
        },

        scroller: {
          paddingLeft: -10,
          margin: 0,
        },

        flexContainer: {
          padding: 0,
          margin: 0,
        },

        indicator: {
          height: "3px",
          borderRadius: "2px",
        },
          scrollButtons: {
      width: "32px",          // ✅ remove reserved space
     margin: 0,
    },
      },
    },

    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontSize: "14px",
          fontWeight: 500,
          minHeight: "42px",
          padding: "6px 14px", // slightly reduced
          margin: 0,

          "&.Mui-selected": {
            color: "#4CAF50",
            fontWeight: 600,
          },

          "&:hover": {
            backgroundColor: "#E8F5E9",
          },
        },
      },
    },
  },
});

export default tabsTheme;
